<template lang="pug">
    article#egressosBeneficios
        Banner
        Menu(:menu="menu")
        Conteudo(:conteudo="pagina.secoes[0].conteudo", v-if="pagina.secoes")
</template>

<script>
import pagina from '@/mixins/pagina'
import Banner from '@sections/EgressosBeneficios/Banner/Banner.vue'
import Menu from '@components/MenuEgressos/MenuEgressos'
import Conteudo from '@components/ConteudoEgressos/ConteudoEgressos'

export default {
    name: "view-egressos-beneficios",
    components: {
        Banner,
        Menu,
        Conteudo
    },
    mixins: [
        pagina
    ],
}
</script>

<style lang="stylus" scoped src="./EgressosBeneficios.styl"></style>